import { FC } from 'react'
export interface SearchProps {
  className?: string
  width?: number
  height?: number
}
const Search: FC<SearchProps> = ({ className, width = 24, height = 24 }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8.30435" cy="8.30435" r="6.80435" stroke="currentColor" />
      <path
        d="M13.326 13.3261L22 22"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Search
